import app from '../action/appAction'

export const initialState = ({
  sidebarShow: true,
})


export default function (state = initialState, action) {
  switch (action.type) {

    case app.TYPES.SET_SLIDE_SHOW:
      return Object.assign({}, state, { sidebarShow: action.payload})

    default:
      return state
  }
}
